import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from 'components/Loading/index';
import api from 'api';
import Util from 'utility.js';

import { 
    addMeal, 
    addTraining,
    setLectureTaskData,
    setAppModeData,
    setProfileData,
    resetRecipe,
    closeModal,
    showMessage
} from 'actions/index';


const mapStateToProps = state => {
    return { data: state };
}

const mapDispatchToProps = dispatch => {
    return {
        addMeal: data => dispatch(addMeal(data)),
        addTraining: data => dispatch(addTraining(data)),
        setLectureTaskData: data => dispatch(setLectureTaskData(data)),
        setProfileData: data => dispatch(setProfileData(data)),
        setAppModeData: data => dispatch(setAppModeData(data)),
        resetRecipe: data => dispatch(resetRecipe(data)),
        closeModal: data => dispatch(closeModal(data)),
        showMessage: data => dispatch(showMessage(data))
    };
};

class LectureSeminarWorkTaskLoad extends Component { 
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            lectureInfo: false
        };    
        this.initTask = this.initTask.bind(this);
    }

    componentDidMount() {
        const lectureId = this.props.match.params.lectureId;
        api('lecturetask/info/' + lectureId).then(result => {
            this.props.setAppModeData({lectureId: lectureId});
            this.props.setAppModeData({lectureInfoData: result.data});
            this.props.setAppModeData({profileId: result.data.profile.id});
            this.props.setAppModeData({undesirableFoods: result.data.undesirable_foods});
            this.props.setAppModeData({watchAttributes: result.data.watch_attributes});
            this.props.setAppModeData({watchAlergens: result.data.watch_alergens});
            this.props.setLectureTaskData(result.data);

            this.setState({
                lectureInfo: result.data,
                loading: false
            }, () => {
                this.initTask();

                if(Util.isCurrentTaskSeminarWork()) {
                    if(Util.isCurrentTaskSeminarWorkAssignment()) {
                        // Current task is seminar work "ASSIGNMENT" submode
                        // Load MJ's example lecturetask
                        api("lecturetask/load/" + lectureId, { post: true, data:{lectureId:lectureId} }).then((res) => {
                            if(typeof res.data.switch_to_profile === 'object') {
                                this.props.setProfileData({
                                    id: res.data.switch_to_profile.id,
                                    data: res.data.switch_to_profile
                                });
                            }        
                            this.props.history.push('/plan');        
                        });        
                    } else {
                        // Current task is seminar work "WORK" submode
                        // Load user's latest saved lecturetask (if any)
                        api("lecturetask/load-latest/" + lectureId, { post: true, data:{lectureId:lectureId} }).then((res) => {
                            this.props.closeModal();
                            this.props.showMessage({
                                show: true,
                                type: 'success',
                                message: 'Byl nahrán uložený úkol "' + res.data.task_meta.title + '"'
                            });                           
                            this.props.history.push('/plan');        
                        });        
                    }
                } else {
                    this.props.history.push('/plan');        
                }
            });
        });
    }

    initTask() {
        const data = this.state.lectureInfo.lecture_data;
        this.props.resetRecipe();

        // Prepare meals, if they are a part of the task
        if(Array.isArray(data.meal_types)) {
            data.meal_types.map(m => {
                let t = m.time.split(':');
                const params = {
                    mealId: m.type * 1,
                    mealLength: 0,
                    startHour: t[0] * 1,
                    startMinute: t[1] * 1,
                    profiles: [Util.getActiveProfileId()]
                };
                this.props.addMeal(params);
            });
        }

        // Prepare trainings, if they are a part of the task
        if(Array.isArray(data.activity_types)) {
            data.activity_types.map(a => {
                if(a.time == "") return;
                if(a.length == "") return;
                let t = a.time.split(':');
                const params = {
                    start: t[0] + ':' + t[1],
                    length: a.length,
                    description: a.title,
                    profiles: [Util.getActiveProfileId()]
                };
                this.props.addTraining(params);
            });
        }
    }

    render() {
        return false;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LectureSeminarWorkTaskLoad);
